<template>
<div style=" height: 100%; margin-top:10px">
    <div class="table2 pt-15 row">
        <h2 class="title-txt"></h2>
        <div class="col-md-3">
            <div class="total_user tu1">
                <div class="user">
                    <div style="background: #F1FFF8;" class="totaluser_chart"><span style="color: #8CD0B0;"><i class="fas fa-2x fa-users"></i></span></div>
                    <div class="text">
                        <h5><strong>Total Number of Admin</strong></h5>
                        <h2>2</h2>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-3">
            <div class="total_user tu2">
                <div class="user">
                    <div style="background: #FFF6EF;" class="totaluser_chart"><span style="color: #FFCCA8;"><i class="fas fa-2x fa-certificate"></i></span></div>
                    <div class="text">
                        <h5><strong>No. of Agents</strong></h5>
                        <h2>6</h2>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-3">
            <div class="total_user tu3">
                <div class="user">
                    <div style="background: #FCF1FF;" class="totaluser_chart"><span style="color: #B874FD;"><i class="fas fa-2x fa-chart-pie"></i></span></div>
                    <div class="text">
                        <h5>Active Agents</h5>
                        <h2>6</h2>
                    </div>

                </div>

            </div>
        </div>
        <div class="col-md-3">
            <div class="total_user tu4">
                <div class="user">
                    <div style="background: #C7E7FB;" class="totaluser_chart"><span style="color: #6BC5FC;"><i class="fas fa-2x fa-chart-pie"></i></span></div>
                    <div class="text">
                        <h5>Inactive Agents</h5>
                        <h2>{{agentStat.inactive}}</h2>
                    </div>

                </div>

            </div>
        </div>
    </div>
    <!-- <div class="row">
        <button style="" class="all_user3" v-if="goBack" @click="bcktoConfigure"><span><i class="fas fa-arrow-left"></i></span> Back to Configure Dashboard</button>
    </div> -->
    <div class="col-md-12" style="margin-top:50px">
        <div class="row" style="padding:0; margin:0">

            <v-row style="margin:0 !important; padding:0 !important">
                <v-col cols="12" style="">
                    <div class="row">
                        <div class="col-md-5 mb-8">
                        Transaction Graph for the month of October
                        </div>
                        <div class="col-md-5 mb-8"> </div>

                        <v-spacer></v-spacer>
                    </div>
                    <!-- <v-dialog v-model="dialog" persistent transition="" max-width="500px">

                        <v-card>
                            <v-card-title style="color:#666; font-size:18px">
                                <span v-if="useredit=='1'">Add user</span>
                                <span v-if="useredit=='2'">Edit user</span>

                                <v-spacer></v-spacer>
                                <v-icon @click="openClose(2)">mdi-close-circle</v-icon>

                            </v-card-title>
                            <v-divider style="margin-top:0px"></v-divider>

                            <v-card-text>
                                <v-row>
                                    <div class="col-md-12 pa-8">
                                        <v-text-field type="text" v-model="firstname" name="Firstname" id="" placeholder="First Name" outlined dense label="First Name"> </v-text-field>

                                        <v-text-field type="text" v-model="lastname" name="Lastname" id="" placeholder="Last Name" outlined dense label="Last Name"></v-text-field>
                                        <v-text-field type="text" class="x" v-model="email" name="" id="" placeholder="E-mail Address of the User" label="Email Address" dense outlined :readonly="useredit==2" :disabled="useredit==2"></v-text-field>

                                        <v-select v-model="dept" :items="deptselect" :menu-props="{ maxHeight: '400' }" label="Select User Department" persistent-hint></v-select>
                                        <v-select v-model="rolefield" :items="rolesselect" :menu-props="{ maxHeight: '400' }" label="Select User Roles" multiple persistent-hint></v-select>
                                    </div>

                                </v-row>
                                <v-card-actions>

                                    <div style="color:white" v-if="useredit == '2'">
                                        <button type="button" class="btn btn-success" @click="edUserfun()">Edit User</button>

                                    </div>
                                    <div style="color:white" v-if="useredit == '1'">
                                        <button type="button" class="btn btn-success" @click="addUserfun">Add User</button>

                                    </div>
                                </v-card-actions>
                            </v-card-text>

                        </v-card>
                    </v-dialog> -->
                    <v-card>
                        <div class="wrapper">
     <apexchart v-if="series[0].data.length>0" width="1200" type="line" :options="chartOptions" :series="series" :key="series.length" height="400"></apexchart>
   </div>
                    </v-card>
                    <v-card>
                        
                    </v-card>
                </v-col>
            </v-row>
        </div>

    </div>

</div>
</template>

<script>
import axios from "axios";
export default {
    data() {
        return {
            days:'',
            series: [{
              name: "Approved",
              data: []
          },
          {
              name: "Failed",
              data: [1000, 2000, 3, 4, 5, 6, 7,8,9,4000,11,12,1000,14,15,16,17]
            }
        ],
          
          chartOptions: {
            chart: {
              height: 350,
              type: 'line',
              zoom: {
                enabled: false
              }
            },
            colors: ['#77B6EA', '#DF0F0F'],
            dataLabels: {
              enabled: false
            },
            stroke: {
              curve: 'straight'
            },
            title: {
              text: 'Product Trends by Month',
              align: 'left'
            },
            grid: {
              row: {
                colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
                opacity: 0.5
              },
            },
            xaxis: {
              categories: this.days,
            }
          },
          
            search:'',
            headers: [{
                    text: 'S/N',
                    align: 'start',
                    value: 'sn',
                    class: 'grey lighten-4 text-center title',
                },
                {
                    text: 'Agent ID',
                    value:'agentID',
                    class: 'grey lighten-4 text-center title',
                },
                {
                    text: 'Terminal ID',
                    value: 'terminalID',
                    class: 'grey lighten-4 text-center title',
                },
                {
                    text: 'Transaction Date',
                    value: 'transactionDate',
                    class: 'grey lighten-4 text-center title',
                },
                {
                    text: 'Amount',
                    value: 'amount',
                    class: 'grey lighten-4 text-center title',
                },
                {
                    text: 'Fee',
                    value: 'fee',
                    class: 'grey lighten-4 text-center title',
                },
                {
                    text: 'Transaction ID',
                    value: 'transactionRef',
                    class: 'grey lighten-4 text-center title',
                },
                {
                    text: 'Type',
                    value: 'transactionType',
                    class: 'grey lighten-4 text-center title',

                },
                {
                    text: 'Status',
                    value: 'transactionStatus',
                    class: 'grey lighten-4 text-center title',

                },
                {
                    text: 'Card Type',
                    value: 'cardType',
                    class: 'grey lighten-4 text-center title',

                },
                {
                    text: 'Bank',
                    value: 'bank',
                    class: 'grey lighten-4 text-center title',

                }
            ],
            desserts: [],
            analytics: {},
            agentStat:{}

        }
    },
    mounted() {
        this.getTransDetails();
        this.fetchAgentStat();
        console.log('llllolllollol');
    },

    methods: {
         range(start, end) {
  return Array(end - start + 1).fill().map((_, idx) => start + idx)
},
        formatPrice(value) {
        let val = value.split('.')
        var valuex = val[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")+'.'+val[1]
        return valuex
    },
        pushData(x){
            const filter = this.desserts.filter(function(e){
                return e.agentID == x
            })
            const data = window.btoa(JSON.stringify(filter));
            return data
        },
       async fetchAgentStat(){
               try {
                const url = process.env.VUE_APP_UB_V1_API_ENDPOINT+'agent-stat'
              const res = await axios.get(url);
                console.log('Stat',res)
              if(res.data.code == 's200'){
                this.agentStat = res.data.message;
              }
            } catch (error) {
                console.log(error);
            }
        },  
        getTransDetails() {

            const url = process.env.VUE_APP_UB_V1_API_ENDPOINT+'fetch-transactions-month'
            axios.get(
                url
            ).then((response) => {
                if (response.data.code == 's200') {
                    this.analytics = response.data.message.analytics;
                    const datttt = response.data.message.vaaaa.filter(function(x){
                        return x.transactionDate = x.transactionDate.split("T")[0];
                    })
                    // first, convert data into a Map with reduce
let counts = datttt.reduce((prev, curr) => {
  let count = prev.get(curr.transactionDate) || 0;
  prev.set(curr.transactionDate, parseInt(curr.amount) + parseInt(count));
  return prev;
}, new Map());

// then, map your counts object back to an array
/* eslint-disable */
let reducedObjArr = [...counts].map(([key, value]) => {
  return {key, value}
})

this.days = this.range(1,17)

var objects = [];

for (var x = 1; x < 17; x++) {
    const datttt = reducedObjArr.filter(function(y){
        if(y.key.split('-')[2] == x){
                        return y.value
        }else{
            return 0
        }
                    })
    // reducedObjArr.forEach(element => {
    //     if(element.key.split("-")[2] == x){
    //     objects.push(element.value)
    //     }else{
    //         objects.push('0')
    //     }
    // });
    if(datttt[0] == undefined){
        objects.push(0)

    }else{ objects.push(datttt[0].value)}
   
   

}
this.series[0].data = objects;
console.log(objects);

                    this.desserts =datttt
                    // response.data.message.transactions.forEach(el => {
                    //     this.desserts.push({
                    //         full_name: el.agentId,
                    //         email: el.transactionDate.split('T')[0],
                    //         roles: el.amount,
                    //         created_at: el.transactionId,
                    //         status: el.transactionStatus == 1 ? 'Successful' : el.transactionStatus == 2 ? 'Fail' : 'Pending',
                    //         actions: el.bank
                    //     })
                    // })
                    // this.$toast.open({
                    //     message: response.data.message,
                    //     type: 'success',
                    //     position: 'top-right'
                    // });
                }
            }).catch(e => {
               console.log(e);
            })

        }
    }

}
</script>

<style lang="scss" scoped>
@import url('https://fonts.cdnfonts.com/css/circular-std');

.text {

    margin-top: -10px;

    h6 {
        font-style: normal;
        font-weight: 400;
        font-size: 13px;
        line-height: 20px;
        color: #4F4F4F;
    }

    h2 {
        font-family: 'Inter' !important;
        font-style: normal;
        font-weight: 500;
        font-size: 28px !important;
        line-height: 20px;
        color: #4F4F4F;
    }
}

.total_user {
    width: 100%;
    height: 149px;
    background: #fff;

    .user {
        width: 100%;
        display: flex;
        padding-top: 10%;

        .totaluser_chart {
            text-align: center;
            width: 40%;
            height: 50px;
            margin-top: 0%;
            width: 50px;
            padding: 10px;
            margin-left: 50px;
            margin-right: 25px
        }
    }
}

.tu1 {
    border-bottom: 4px solid #5DB68B;
}

.tu2 {
    border-bottom: 4px solid #FFCCA8;
}

.tu3 {
    border-bottom: 4px solid #B874FD;
}

.tu4 {
    border-bottom: 4px solid #6BC5FC;
}
</style>
